/** 管理画面：カレンダー⇔一覧のスクロール（ページ全体を動かしすぎない） */

export const ADMIN_CALENDAR_ANCHOR_ID = "admin-shared-month-calendar";
export const ADMIN_EVENTS_LIST_SCROLL_ID = "admin-events-list-scroll";

export function scrollToAdminCalendar(): void {
  document.getElementById(ADMIN_CALENDAR_ANCHOR_ID)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** 一覧テーブル内でその日の行へ（外側は admin-events-list-scroll がスクロール） */
export function scrollToAdminListRow(dayKey: string): void {
  const wrap = document.getElementById(ADMIN_EVENTS_LIST_SCROLL_ID);
  const row = wrap?.querySelector(`tr[data-admin-row-date="${dayKey}"]`);
  if (row instanceof HTMLElement) {
    row.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  const fallback = document.querySelector(`tr[data-admin-row-date="${dayKey}"]`);
  if (fallback instanceof HTMLElement) fallback.scrollIntoView({ behavior: "smooth", block: "nearest" });
}

/** 一覧ペインを画面内に最小限だけ見せる（カレンダーはできるだけ残す） */
export function revealAdminEventsList(): void {
  document.getElementById(ADMIN_EVENTS_LIST_SCROLL_ID)?.scrollIntoView({ behavior: "smooth", block: "nearest" });
}
